var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from 'class-transformer';
import { IsEnum, IsOptional, IsString } from 'class-validator';
import { Role } from '../roles/enums/role.enum.js';
import { CaregiverRelationship } from '../user/enums/caregiver.enum.js';
/**
 * A Person that waits for the session's Account to accept a join invite
 * (`GET /join-invites`, #1825): what the inviting office entered, so the holder
 * can tell whether the invite is meant for them.
 *
 * A caregiver entry's invite (#1840) is listed the same way: the Person is the
 * patient, `caregiverEntryId` is set, and the holder is asked whether they are
 * the caregiver, by the caregiver's name and relationship and the patient's name.
 */
export class JoinInviteDto {
    /** The invited Person, or for a caregiver entry the patient it is on. */
    userId;
    /** Set for a caregiver entry's invite; accepted through its own route. */
    caregiverEntryId;
    /** The caregiver's name as the office entered it. */
    caregiverName;
    caregiverRelationship;
    officeId;
    /**
     * What the office is called, as in {@link AccountOfficeDto}: the inviting
     * location for a patient, the allowed ones for staff (TM-9665).
     */
    officeLocationName;
    firstName;
    lastName;
    /** As the patient file carries it (an ISO timestamp); never for a caregiver entry. */
    birthdate;
    role;
}
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], JoinInviteDto.prototype, "userId", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsString(),
    __metadata("design:type", Object)
], JoinInviteDto.prototype, "caregiverEntryId", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsString(),
    __metadata("design:type", Object)
], JoinInviteDto.prototype, "caregiverName", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsEnum(CaregiverRelationship),
    __metadata("design:type", Object)
], JoinInviteDto.prototype, "caregiverRelationship", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], JoinInviteDto.prototype, "officeId", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], JoinInviteDto.prototype, "officeLocationName", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsString(),
    __metadata("design:type", Object)
], JoinInviteDto.prototype, "firstName", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsString(),
    __metadata("design:type", Object)
], JoinInviteDto.prototype, "lastName", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsString(),
    __metadata("design:type", Object)
], JoinInviteDto.prototype, "birthdate", void 0);
__decorate([
    Expose(),
    IsEnum(Role),
    __metadata("design:type", String)
], JoinInviteDto.prototype, "role", void 0);
/** The office the accepted Person belongs to; the app switches into it. */
export class AcceptedJoinInviteDto {
    officeId;
}
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], AcceptedJoinInviteDto.prototype, "officeId", void 0);
//# sourceMappingURL=join-invite.js.map